// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"6af2b748","148":"871bd2b5","167":"40024912","348":"82cd3f81","455":"cbd0ff61","579":"4f57d3e4","755":"abca4480","758":"4479da9f"}[chunkId] + ".chunk.js";
};